module.exports = __webpack_public_path__ + "media/images/sp/specials/common/plan_yoso_location-68957e40e0eec39d5787baf30d107179.jpg";